// Shared metadata for award kinds and directions. Codes match Award::KINDS /
// Award::DIRECTIONS on the server; the UI uses the Ukrainian labels and a Font
// Awesome glyph for badges, filter tabs and the blank (no-photo) tile.
export const KINDS = [
  { code: "medal",       one: "Медаль",     many: "Медалі",     icon: "fa-medal" },
  { code: "cup",         one: "Кубок",      many: "Кубки",      icon: "fa-trophy" },
  { code: "diploma",     one: "Диплом",     many: "Дипломи",    icon: "fa-scroll" },
  { code: "certificate", one: "Сертифікат", many: "Сертифікати", icon: "fa-file-signature" },
]

export const DIRECTIONS = [
  { code: "judo",      label: "Дзюдо",          icon: "fa-hand-fist" },
  { code: "sambo",     label: "Самбо",          icon: "fa-hand-back-fist" },
  { code: "athletics", label: "Легка атлетика", icon: "fa-person-running" },
  { code: "karting",   label: "Картинг",        icon: "fa-flag-checkered" },
  { code: "chess",     label: "Шахи",           icon: "fa-chess-knight" },
  { code: "school",    label: "Навчання",       icon: "fa-graduation-cap" },
  { code: "other",     label: "Інше",           icon: "fa-star" },
]

export const kindMeta = (code) => KINDS.find((k) => k.code === code) || KINDS[0]
export const directionMeta = (code) => DIRECTIONS.find((d) => d.code === code) || DIRECTIONS[DIRECTIONS.length - 1]
